import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";

export default function Genres() {
  const [genres, setGenres] = useState([]);
  useEffect(() => { api.get("/genres").then((r) => setGenres(r.data)); }, []);

  return (
    <div>
      <h1 className="font-display text-4xl sm:text-5xl font-extrabold mb-8">Genres</h1>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
        {genres.map((g) => (
          <Link key={g.slug} to={`/genres/${g.slug}`} data-testid={`genre-card-${g.slug}`}
            className="group relative aspect-square rounded-2xl overflow-hidden border border-white/10 card-hover">
            {g.image ? (
              <img src={g.image} alt={g.name} className="absolute inset-0 w-full h-full object-cover opacity-60 group-hover:opacity-80 transition-opacity" />
            ) : (
              <div
                className="absolute inset-0"
                style={{ background: `linear-gradient(135deg, ${g.accent || "#00F0FF"}66, #0A0A0E 70%)` }}
                data-testid={`genre-card-placeholder-${g.slug}`}
              />
            )}
            <div className="absolute inset-0 bg-gradient-to-br" style={{ background: `linear-gradient(135deg, ${g.accent || "#00F0FF"}40, transparent 60%)` }} />
            <div className="absolute inset-0 scrim-bottom" />
            <div className="absolute bottom-4 left-4 right-4">
              <div className="font-display text-xl sm:text-2xl font-extrabold">{g.name}</div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
